import API from "../util/api";

export const deleteDraftImage = async (payload) => {
  let data = null;

  await API.post('/remove-media', payload)
    .then(res => {
      data = res.data.data;
    })
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return data;
}